__turbopack_context__.v({
  "bg-lg-background": "JwZCoa_bg-lg-background",
  "bg-lg-black": "JwZCoa_bg-lg-black",
  "bg-lg-danger": "JwZCoa_bg-lg-danger",
  "bg-lg-dangerLight": "JwZCoa_bg-lg-dangerLight",
  "bg-lg-dangerVeryLight": "JwZCoa_bg-lg-dangerVeryLight",
  "bg-lg-default": "JwZCoa_bg-lg-default",
  "bg-lg-facebook": "JwZCoa_bg-lg-facebook",
  "bg-lg-featured": "JwZCoa_bg-lg-featured",
  "bg-lg-featuredLight": "JwZCoa_bg-lg-featuredLight",
  "bg-lg-featuredVeryLight": "JwZCoa_bg-lg-featuredVeryLight",
  "bg-lg-focus-ring-color": "JwZCoa_bg-lg-focus-ring-color",
  "bg-lg-google": "JwZCoa_bg-lg-google",
  "bg-lg-gray0": "JwZCoa_bg-lg-gray0",
  "bg-lg-gray1": "JwZCoa_bg-lg-gray1",
  "bg-lg-gray2": "JwZCoa_bg-lg-gray2",
  "bg-lg-gray3": "JwZCoa_bg-lg-gray3",
  "bg-lg-gray4": "JwZCoa_bg-lg-gray4",
  "bg-lg-gray5": "JwZCoa_bg-lg-gray5",
  "bg-lg-gray6": "JwZCoa_bg-lg-gray6",
  "bg-lg-gray7": "JwZCoa_bg-lg-gray7",
  "bg-lg-gray8": "JwZCoa_bg-lg-gray8",
  "bg-lg-gray9": "JwZCoa_bg-lg-gray9",
  "bg-lg-info": "JwZCoa_bg-lg-info",
  "bg-lg-lightBlack": "JwZCoa_bg-lg-lightBlack",
  "bg-lg-linkedin": "JwZCoa_bg-lg-linkedin",
  "bg-lg-primary": "JwZCoa_bg-lg-primary",
  "bg-lg-primaryLight": "JwZCoa_bg-lg-primaryLight",
  "bg-lg-primaryVeryLight": "JwZCoa_bg-lg-primaryVeryLight",
  "bg-lg-secondary": "JwZCoa_bg-lg-secondary",
  "bg-lg-secondaryLight": "JwZCoa_bg-lg-secondaryLight",
  "bg-lg-secondaryVeryLight": "JwZCoa_bg-lg-secondaryVeryLight",
  "bg-lg-success": "JwZCoa_bg-lg-success",
  "bg-lg-successLight": "JwZCoa_bg-lg-successLight",
  "bg-lg-successVeryLight": "JwZCoa_bg-lg-successVeryLight",
  "bg-lg-transparent": "JwZCoa_bg-lg-transparent",
  "bg-lg-twitter": "JwZCoa_bg-lg-twitter",
  "bg-lg-warning": "JwZCoa_bg-lg-warning",
  "bg-lg-warningLight": "JwZCoa_bg-lg-warningLight",
  "bg-lg-warningVeryLight": "JwZCoa_bg-lg-warningVeryLight",
  "bg-lg-white": "JwZCoa_bg-lg-white",
  "bg-lg-xing": "JwZCoa_bg-lg-xing",
  "bg-md-background": "JwZCoa_bg-md-background",
  "bg-md-black": "JwZCoa_bg-md-black",
  "bg-md-danger": "JwZCoa_bg-md-danger",
  "bg-md-dangerLight": "JwZCoa_bg-md-dangerLight",
  "bg-md-dangerVeryLight": "JwZCoa_bg-md-dangerVeryLight",
  "bg-md-default": "JwZCoa_bg-md-default",
  "bg-md-facebook": "JwZCoa_bg-md-facebook",
  "bg-md-featured": "JwZCoa_bg-md-featured",
  "bg-md-featuredLight": "JwZCoa_bg-md-featuredLight",
  "bg-md-featuredVeryLight": "JwZCoa_bg-md-featuredVeryLight",
  "bg-md-focus-ring-color": "JwZCoa_bg-md-focus-ring-color",
  "bg-md-google": "JwZCoa_bg-md-google",
  "bg-md-gray0": "JwZCoa_bg-md-gray0",
  "bg-md-gray1": "JwZCoa_bg-md-gray1",
  "bg-md-gray2": "JwZCoa_bg-md-gray2",
  "bg-md-gray3": "JwZCoa_bg-md-gray3",
  "bg-md-gray4": "JwZCoa_bg-md-gray4",
  "bg-md-gray5": "JwZCoa_bg-md-gray5",
  "bg-md-gray6": "JwZCoa_bg-md-gray6",
  "bg-md-gray7": "JwZCoa_bg-md-gray7",
  "bg-md-gray8": "JwZCoa_bg-md-gray8",
  "bg-md-gray9": "JwZCoa_bg-md-gray9",
  "bg-md-info": "JwZCoa_bg-md-info",
  "bg-md-lightBlack": "JwZCoa_bg-md-lightBlack",
  "bg-md-linkedin": "JwZCoa_bg-md-linkedin",
  "bg-md-primary": "JwZCoa_bg-md-primary",
  "bg-md-primaryLight": "JwZCoa_bg-md-primaryLight",
  "bg-md-primaryVeryLight": "JwZCoa_bg-md-primaryVeryLight",
  "bg-md-secondary": "JwZCoa_bg-md-secondary",
  "bg-md-secondaryLight": "JwZCoa_bg-md-secondaryLight",
  "bg-md-secondaryVeryLight": "JwZCoa_bg-md-secondaryVeryLight",
  "bg-md-success": "JwZCoa_bg-md-success",
  "bg-md-successLight": "JwZCoa_bg-md-successLight",
  "bg-md-successVeryLight": "JwZCoa_bg-md-successVeryLight",
  "bg-md-transparent": "JwZCoa_bg-md-transparent",
  "bg-md-twitter": "JwZCoa_bg-md-twitter",
  "bg-md-warning": "JwZCoa_bg-md-warning",
  "bg-md-warningLight": "JwZCoa_bg-md-warningLight",
  "bg-md-warningVeryLight": "JwZCoa_bg-md-warningVeryLight",
  "bg-md-white": "JwZCoa_bg-md-white",
  "bg-md-xing": "JwZCoa_bg-md-xing",
  "bg-sm-background": "JwZCoa_bg-sm-background",
  "bg-sm-black": "JwZCoa_bg-sm-black",
  "bg-sm-danger": "JwZCoa_bg-sm-danger",
  "bg-sm-dangerLight": "JwZCoa_bg-sm-dangerLight",
  "bg-sm-dangerVeryLight": "JwZCoa_bg-sm-dangerVeryLight",
  "bg-sm-default": "JwZCoa_bg-sm-default",
  "bg-sm-facebook": "JwZCoa_bg-sm-facebook",
  "bg-sm-featured": "JwZCoa_bg-sm-featured",
  "bg-sm-featuredLight": "JwZCoa_bg-sm-featuredLight",
  "bg-sm-featuredVeryLight": "JwZCoa_bg-sm-featuredVeryLight",
  "bg-sm-focus-ring-color": "JwZCoa_bg-sm-focus-ring-color",
  "bg-sm-google": "JwZCoa_bg-sm-google",
  "bg-sm-gray0": "JwZCoa_bg-sm-gray0",
  "bg-sm-gray1": "JwZCoa_bg-sm-gray1",
  "bg-sm-gray2": "JwZCoa_bg-sm-gray2",
  "bg-sm-gray3": "JwZCoa_bg-sm-gray3",
  "bg-sm-gray4": "JwZCoa_bg-sm-gray4",
  "bg-sm-gray5": "JwZCoa_bg-sm-gray5",
  "bg-sm-gray6": "JwZCoa_bg-sm-gray6",
  "bg-sm-gray7": "JwZCoa_bg-sm-gray7",
  "bg-sm-gray8": "JwZCoa_bg-sm-gray8",
  "bg-sm-gray9": "JwZCoa_bg-sm-gray9",
  "bg-sm-info": "JwZCoa_bg-sm-info",
  "bg-sm-lightBlack": "JwZCoa_bg-sm-lightBlack",
  "bg-sm-linkedin": "JwZCoa_bg-sm-linkedin",
  "bg-sm-primary": "JwZCoa_bg-sm-primary",
  "bg-sm-primaryLight": "JwZCoa_bg-sm-primaryLight",
  "bg-sm-primaryVeryLight": "JwZCoa_bg-sm-primaryVeryLight",
  "bg-sm-secondary": "JwZCoa_bg-sm-secondary",
  "bg-sm-secondaryLight": "JwZCoa_bg-sm-secondaryLight",
  "bg-sm-secondaryVeryLight": "JwZCoa_bg-sm-secondaryVeryLight",
  "bg-sm-success": "JwZCoa_bg-sm-success",
  "bg-sm-successLight": "JwZCoa_bg-sm-successLight",
  "bg-sm-successVeryLight": "JwZCoa_bg-sm-successVeryLight",
  "bg-sm-transparent": "JwZCoa_bg-sm-transparent",
  "bg-sm-twitter": "JwZCoa_bg-sm-twitter",
  "bg-sm-warning": "JwZCoa_bg-sm-warning",
  "bg-sm-warningLight": "JwZCoa_bg-sm-warningLight",
  "bg-sm-warningVeryLight": "JwZCoa_bg-sm-warningVeryLight",
  "bg-sm-white": "JwZCoa_bg-sm-white",
  "bg-sm-xing": "JwZCoa_bg-sm-xing",
  "bg-xl-background": "JwZCoa_bg-xl-background",
  "bg-xl-black": "JwZCoa_bg-xl-black",
  "bg-xl-danger": "JwZCoa_bg-xl-danger",
  "bg-xl-dangerLight": "JwZCoa_bg-xl-dangerLight",
  "bg-xl-dangerVeryLight": "JwZCoa_bg-xl-dangerVeryLight",
  "bg-xl-default": "JwZCoa_bg-xl-default",
  "bg-xl-facebook": "JwZCoa_bg-xl-facebook",
  "bg-xl-featured": "JwZCoa_bg-xl-featured",
  "bg-xl-featuredLight": "JwZCoa_bg-xl-featuredLight",
  "bg-xl-featuredVeryLight": "JwZCoa_bg-xl-featuredVeryLight",
  "bg-xl-focus-ring-color": "JwZCoa_bg-xl-focus-ring-color",
  "bg-xl-google": "JwZCoa_bg-xl-google",
  "bg-xl-gray0": "JwZCoa_bg-xl-gray0",
  "bg-xl-gray1": "JwZCoa_bg-xl-gray1",
  "bg-xl-gray2": "JwZCoa_bg-xl-gray2",
  "bg-xl-gray3": "JwZCoa_bg-xl-gray3",
  "bg-xl-gray4": "JwZCoa_bg-xl-gray4",
  "bg-xl-gray5": "JwZCoa_bg-xl-gray5",
  "bg-xl-gray6": "JwZCoa_bg-xl-gray6",
  "bg-xl-gray7": "JwZCoa_bg-xl-gray7",
  "bg-xl-gray8": "JwZCoa_bg-xl-gray8",
  "bg-xl-gray9": "JwZCoa_bg-xl-gray9",
  "bg-xl-info": "JwZCoa_bg-xl-info",
  "bg-xl-lightBlack": "JwZCoa_bg-xl-lightBlack",
  "bg-xl-linkedin": "JwZCoa_bg-xl-linkedin",
  "bg-xl-primary": "JwZCoa_bg-xl-primary",
  "bg-xl-primaryLight": "JwZCoa_bg-xl-primaryLight",
  "bg-xl-primaryVeryLight": "JwZCoa_bg-xl-primaryVeryLight",
  "bg-xl-secondary": "JwZCoa_bg-xl-secondary",
  "bg-xl-secondaryLight": "JwZCoa_bg-xl-secondaryLight",
  "bg-xl-secondaryVeryLight": "JwZCoa_bg-xl-secondaryVeryLight",
  "bg-xl-success": "JwZCoa_bg-xl-success",
  "bg-xl-successLight": "JwZCoa_bg-xl-successLight",
  "bg-xl-successVeryLight": "JwZCoa_bg-xl-successVeryLight",
  "bg-xl-transparent": "JwZCoa_bg-xl-transparent",
  "bg-xl-twitter": "JwZCoa_bg-xl-twitter",
  "bg-xl-warning": "JwZCoa_bg-xl-warning",
  "bg-xl-warningLight": "JwZCoa_bg-xl-warningLight",
  "bg-xl-warningVeryLight": "JwZCoa_bg-xl-warningVeryLight",
  "bg-xl-white": "JwZCoa_bg-xl-white",
  "bg-xl-xing": "JwZCoa_bg-xl-xing",
  "color-lg-background": "JwZCoa_color-lg-background",
  "color-lg-black": "JwZCoa_color-lg-black",
  "color-lg-danger": "JwZCoa_color-lg-danger",
  "color-lg-dangerLight": "JwZCoa_color-lg-dangerLight",
  "color-lg-dangerVeryLight": "JwZCoa_color-lg-dangerVeryLight",
  "color-lg-default": "JwZCoa_color-lg-default",
  "color-lg-facebook": "JwZCoa_color-lg-facebook",
  "color-lg-featured": "JwZCoa_color-lg-featured",
  "color-lg-featuredLight": "JwZCoa_color-lg-featuredLight",
  "color-lg-featuredVeryLight": "JwZCoa_color-lg-featuredVeryLight",
  "color-lg-focus-ring-color": "JwZCoa_color-lg-focus-ring-color",
  "color-lg-google": "JwZCoa_color-lg-google",
  "color-lg-gray0": "JwZCoa_color-lg-gray0",
  "color-lg-gray1": "JwZCoa_color-lg-gray1",
  "color-lg-gray2": "JwZCoa_color-lg-gray2",
  "color-lg-gray3": "JwZCoa_color-lg-gray3",
  "color-lg-gray4": "JwZCoa_color-lg-gray4",
  "color-lg-gray5": "JwZCoa_color-lg-gray5",
  "color-lg-gray6": "JwZCoa_color-lg-gray6",
  "color-lg-gray7": "JwZCoa_color-lg-gray7",
  "color-lg-gray8": "JwZCoa_color-lg-gray8",
  "color-lg-gray9": "JwZCoa_color-lg-gray9",
  "color-lg-info": "JwZCoa_color-lg-info",
  "color-lg-lightBlack": "JwZCoa_color-lg-lightBlack",
  "color-lg-linkedin": "JwZCoa_color-lg-linkedin",
  "color-lg-primary": "JwZCoa_color-lg-primary",
  "color-lg-primaryLight": "JwZCoa_color-lg-primaryLight",
  "color-lg-primaryVeryLight": "JwZCoa_color-lg-primaryVeryLight",
  "color-lg-secondary": "JwZCoa_color-lg-secondary",
  "color-lg-secondaryLight": "JwZCoa_color-lg-secondaryLight",
  "color-lg-secondaryVeryLight": "JwZCoa_color-lg-secondaryVeryLight",
  "color-lg-success": "JwZCoa_color-lg-success",
  "color-lg-successLight": "JwZCoa_color-lg-successLight",
  "color-lg-successVeryLight": "JwZCoa_color-lg-successVeryLight",
  "color-lg-transparent": "JwZCoa_color-lg-transparent",
  "color-lg-twitter": "JwZCoa_color-lg-twitter",
  "color-lg-warning": "JwZCoa_color-lg-warning",
  "color-lg-warningLight": "JwZCoa_color-lg-warningLight",
  "color-lg-warningVeryLight": "JwZCoa_color-lg-warningVeryLight",
  "color-lg-white": "JwZCoa_color-lg-white",
  "color-lg-xing": "JwZCoa_color-lg-xing",
  "color-md-background": "JwZCoa_color-md-background",
  "color-md-black": "JwZCoa_color-md-black",
  "color-md-danger": "JwZCoa_color-md-danger",
  "color-md-dangerLight": "JwZCoa_color-md-dangerLight",
  "color-md-dangerVeryLight": "JwZCoa_color-md-dangerVeryLight",
  "color-md-default": "JwZCoa_color-md-default",
  "color-md-facebook": "JwZCoa_color-md-facebook",
  "color-md-featured": "JwZCoa_color-md-featured",
  "color-md-featuredLight": "JwZCoa_color-md-featuredLight",
  "color-md-featuredVeryLight": "JwZCoa_color-md-featuredVeryLight",
  "color-md-focus-ring-color": "JwZCoa_color-md-focus-ring-color",
  "color-md-google": "JwZCoa_color-md-google",
  "color-md-gray0": "JwZCoa_color-md-gray0",
  "color-md-gray1": "JwZCoa_color-md-gray1",
  "color-md-gray2": "JwZCoa_color-md-gray2",
  "color-md-gray3": "JwZCoa_color-md-gray3",
  "color-md-gray4": "JwZCoa_color-md-gray4",
  "color-md-gray5": "JwZCoa_color-md-gray5",
  "color-md-gray6": "JwZCoa_color-md-gray6",
  "color-md-gray7": "JwZCoa_color-md-gray7",
  "color-md-gray8": "JwZCoa_color-md-gray8",
  "color-md-gray9": "JwZCoa_color-md-gray9",
  "color-md-info": "JwZCoa_color-md-info",
  "color-md-lightBlack": "JwZCoa_color-md-lightBlack",
  "color-md-linkedin": "JwZCoa_color-md-linkedin",
  "color-md-primary": "JwZCoa_color-md-primary",
  "color-md-primaryLight": "JwZCoa_color-md-primaryLight",
  "color-md-primaryVeryLight": "JwZCoa_color-md-primaryVeryLight",
  "color-md-secondary": "JwZCoa_color-md-secondary",
  "color-md-secondaryLight": "JwZCoa_color-md-secondaryLight",
  "color-md-secondaryVeryLight": "JwZCoa_color-md-secondaryVeryLight",
  "color-md-success": "JwZCoa_color-md-success",
  "color-md-successLight": "JwZCoa_color-md-successLight",
  "color-md-successVeryLight": "JwZCoa_color-md-successVeryLight",
  "color-md-transparent": "JwZCoa_color-md-transparent",
  "color-md-twitter": "JwZCoa_color-md-twitter",
  "color-md-warning": "JwZCoa_color-md-warning",
  "color-md-warningLight": "JwZCoa_color-md-warningLight",
  "color-md-warningVeryLight": "JwZCoa_color-md-warningVeryLight",
  "color-md-white": "JwZCoa_color-md-white",
  "color-md-xing": "JwZCoa_color-md-xing",
  "color-sm-background": "JwZCoa_color-sm-background",
  "color-sm-black": "JwZCoa_color-sm-black",
  "color-sm-danger": "JwZCoa_color-sm-danger",
  "color-sm-dangerLight": "JwZCoa_color-sm-dangerLight",
  "color-sm-dangerVeryLight": "JwZCoa_color-sm-dangerVeryLight",
  "color-sm-default": "JwZCoa_color-sm-default",
  "color-sm-facebook": "JwZCoa_color-sm-facebook",
  "color-sm-featured": "JwZCoa_color-sm-featured",
  "color-sm-featuredLight": "JwZCoa_color-sm-featuredLight",
  "color-sm-featuredVeryLight": "JwZCoa_color-sm-featuredVeryLight",
  "color-sm-focus-ring-color": "JwZCoa_color-sm-focus-ring-color",
  "color-sm-google": "JwZCoa_color-sm-google",
  "color-sm-gray0": "JwZCoa_color-sm-gray0",
  "color-sm-gray1": "JwZCoa_color-sm-gray1",
  "color-sm-gray2": "JwZCoa_color-sm-gray2",
  "color-sm-gray3": "JwZCoa_color-sm-gray3",
  "color-sm-gray4": "JwZCoa_color-sm-gray4",
  "color-sm-gray5": "JwZCoa_color-sm-gray5",
  "color-sm-gray6": "JwZCoa_color-sm-gray6",
  "color-sm-gray7": "JwZCoa_color-sm-gray7",
  "color-sm-gray8": "JwZCoa_color-sm-gray8",
  "color-sm-gray9": "JwZCoa_color-sm-gray9",
  "color-sm-info": "JwZCoa_color-sm-info",
  "color-sm-lightBlack": "JwZCoa_color-sm-lightBlack",
  "color-sm-linkedin": "JwZCoa_color-sm-linkedin",
  "color-sm-primary": "JwZCoa_color-sm-primary",
  "color-sm-primaryLight": "JwZCoa_color-sm-primaryLight",
  "color-sm-primaryVeryLight": "JwZCoa_color-sm-primaryVeryLight",
  "color-sm-secondary": "JwZCoa_color-sm-secondary",
  "color-sm-secondaryLight": "JwZCoa_color-sm-secondaryLight",
  "color-sm-secondaryVeryLight": "JwZCoa_color-sm-secondaryVeryLight",
  "color-sm-success": "JwZCoa_color-sm-success",
  "color-sm-successLight": "JwZCoa_color-sm-successLight",
  "color-sm-successVeryLight": "JwZCoa_color-sm-successVeryLight",
  "color-sm-transparent": "JwZCoa_color-sm-transparent",
  "color-sm-twitter": "JwZCoa_color-sm-twitter",
  "color-sm-warning": "JwZCoa_color-sm-warning",
  "color-sm-warningLight": "JwZCoa_color-sm-warningLight",
  "color-sm-warningVeryLight": "JwZCoa_color-sm-warningVeryLight",
  "color-sm-white": "JwZCoa_color-sm-white",
  "color-sm-xing": "JwZCoa_color-sm-xing",
  "color-xl-background": "JwZCoa_color-xl-background",
  "color-xl-black": "JwZCoa_color-xl-black",
  "color-xl-danger": "JwZCoa_color-xl-danger",
  "color-xl-dangerLight": "JwZCoa_color-xl-dangerLight",
  "color-xl-dangerVeryLight": "JwZCoa_color-xl-dangerVeryLight",
  "color-xl-default": "JwZCoa_color-xl-default",
  "color-xl-facebook": "JwZCoa_color-xl-facebook",
  "color-xl-featured": "JwZCoa_color-xl-featured",
  "color-xl-featuredLight": "JwZCoa_color-xl-featuredLight",
  "color-xl-featuredVeryLight": "JwZCoa_color-xl-featuredVeryLight",
  "color-xl-focus-ring-color": "JwZCoa_color-xl-focus-ring-color",
  "color-xl-google": "JwZCoa_color-xl-google",
  "color-xl-gray0": "JwZCoa_color-xl-gray0",
  "color-xl-gray1": "JwZCoa_color-xl-gray1",
  "color-xl-gray2": "JwZCoa_color-xl-gray2",
  "color-xl-gray3": "JwZCoa_color-xl-gray3",
  "color-xl-gray4": "JwZCoa_color-xl-gray4",
  "color-xl-gray5": "JwZCoa_color-xl-gray5",
  "color-xl-gray6": "JwZCoa_color-xl-gray6",
  "color-xl-gray7": "JwZCoa_color-xl-gray7",
  "color-xl-gray8": "JwZCoa_color-xl-gray8",
  "color-xl-gray9": "JwZCoa_color-xl-gray9",
  "color-xl-info": "JwZCoa_color-xl-info",
  "color-xl-lightBlack": "JwZCoa_color-xl-lightBlack",
  "color-xl-linkedin": "JwZCoa_color-xl-linkedin",
  "color-xl-primary": "JwZCoa_color-xl-primary",
  "color-xl-primaryLight": "JwZCoa_color-xl-primaryLight",
  "color-xl-primaryVeryLight": "JwZCoa_color-xl-primaryVeryLight",
  "color-xl-secondary": "JwZCoa_color-xl-secondary",
  "color-xl-secondaryLight": "JwZCoa_color-xl-secondaryLight",
  "color-xl-secondaryVeryLight": "JwZCoa_color-xl-secondaryVeryLight",
  "color-xl-success": "JwZCoa_color-xl-success",
  "color-xl-successLight": "JwZCoa_color-xl-successLight",
  "color-xl-successVeryLight": "JwZCoa_color-xl-successVeryLight",
  "color-xl-transparent": "JwZCoa_color-xl-transparent",
  "color-xl-twitter": "JwZCoa_color-xl-twitter",
  "color-xl-warning": "JwZCoa_color-xl-warning",
  "color-xl-warningLight": "JwZCoa_color-xl-warningLight",
  "color-xl-warningVeryLight": "JwZCoa_color-xl-warningVeryLight",
  "color-xl-white": "JwZCoa_color-xl-white",
  "color-xl-xing": "JwZCoa_color-xl-xing",
  "ripple": "JwZCoa_ripple",
});
